import { WidgetAutocheck } from "@redotech/redo-storefront-widget-common/widget";

/**
 * Whether any feature living inside the `redo-storefront` overlay is active for
 * this team. `index.ts` uses it to decide whether to dynamically import the
 * overlay chunk at all, so **every** overlay-hosted surface must be represented
 * here — a surface missing from this predicate can never render, no matter how
 * it is configured downstream.
 *
 * Kept in its own leaf module (type-only autocheck import) so it can be tested
 * without executing the storefront bootstrap.
 */
export function shouldRenderRedoStorefrontOverlay(
  autocheck: WidgetAutocheck,
): boolean {
  return (
    autocheck.marketing.enabled ||
    (autocheck.customerAccounts.enabled &&
      !!autocheck.customerAccounts.saveForLaterPanel?.enabled) ||
    autocheck.loyalty.enabled ||
    autocheck.reviews.enabled ||
    autocheck.conversion.enabled ||
    // HSA hosts two overlay surfaces (the PDP badge and the cart eligibility
    // widget); each renders only when its placement is configured, so the
    // chunk is only worth loading when at least one of them is.
    (autocheck.hsa.enabled &&
      !!(
        autocheck.hsa.pdpWidgetPlacement ||
        autocheck.hsa.cartWidgetPlacements?.length
      ))
  );
}
